const headers = {
  name: "Journal List",
  navigate: {
    tabs: [
      {
        name: "Journal List",
        path: "/app/manual-journals",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;